// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_IAJ","cls2":"ImpactHubModal-cls2_lzN ImpactHubModal-cls1_IAJ"};